"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IconContainer_1 = __importStar(require("../IconContainer"));
const CloseIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsx)(IconContainer_1.StyledSvg, { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M4.22187 5.63604C3.83135 6.02656 3.83135 6.65973 4.22187 7.05025L9.17162 12L4.22187 16.9497C3.83135 17.3403 3.83135 17.9734 4.22187 18.364L5.63608 19.7782C6.02661 20.1687 6.65977 20.1687 7.0503 19.7782L12 14.8284L16.9498 19.7782C17.3403 20.1687 17.9735 20.1687 18.364 19.7782L19.7782 18.364C20.1687 17.9734 20.1687 17.3403 19.7782 16.9497L14.8285 12L19.7782 7.05025C20.1687 6.65973 20.1687 6.02656 19.7782 5.63604L18.364 4.22183C17.9735 3.8313 17.3403 3.8313 16.9498 4.22183L12 9.17157L7.0503 4.22183C6.65977 3.8313 6.02661 3.8313 5.63608 4.22183L4.22187 5.63604Z", fillRule: "evenodd" }) }));
exports.default = (0, IconContainer_1.default)(CloseIcon);
//# sourceMappingURL=index.js.map